import { useEffect, useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import yup from "../../utils/yup";
import Form from "../../components/form/Form";
import { getEmployments } from "../../services/EmploymentService";
import { getCurrentUser } from "../../utils/utils";
import { Roles } from "../../utils/constants";

const StatisticsFilter = ({ categories, setFilterData }) => {
  const user = getCurrentUser();
  const [users, setUsers] = useState(null);
  const [formDetails, setFormDetails] = useState({
    details: null,
    schema: null,
  });

  const form = useForm({
    resolver: yupResolver(formDetails.schema),
    mode: "onChange",
  });

  useEffect(() => {
    if (!categories || !users) {
      return;
    }

    setFormDetails({
      schema: yup
        .object()
        .shape({
          from_date: yup
            .date()
            .nullable()
            .transform((v) => (v instanceof Date && !isNaN(v) ? v : null))
            .test(
              "start-end-date-val",
              "You must enter a starting date.",
              function (value) {
                const { to_date } = this.parent;
                return !to_date || !!value;
              }
            ),
          to_date: yup
            .date()
            .nullable()
            .transform((v) => (v instanceof Date && !isNaN(v) ? v : null))
            .test(
              "end-time-limit",
              "The end time can't be more than 2 months in the future",
              (toDate) => {
                if (!toDate) return true;
                const now = new Date();
                return (
                  toDate.getFullYear() === now.getFullYear() &&
                  toDate.getMonth() - now.getMonth() <= 2
                );
              }
            )
            .when("from_date", ([fromDate], yup) => {
              if (!fromDate && fromDate instanceof Date && !isNaN(fromDate)) {
                return yup.min(
                  fromDate,
                  "The end time cannot be before start time."
                );
              }
            }),
        })
        .required(),
      details: {
        submitButtonLabel: "Filter",
        columns: 2,
        steps: [
          {
            name: "from_date",
            type: "text",
            label: "Start Date",
            htmlType: "date",
          },
          {
            name: "to_date",
            type: "text",
            label: "End Date",
            htmlType: "date",
          },
          {
            name: "categories",
            label: "Categories",
            type: "select-text-input",
            multiple: true,
            options: categories.map((cat) => ({
              value: cat.id,
              label: cat.name,
            })),
          },
          {
            name: "employees",
            label:
              user.role === Roles.EMPLOYER.value ? "Employees" : "Employers",
            type: "select-text-input",
            multiple: true,
            options: users.map((user) => ({
              value: user,
              label: user,
            })),
          },
        ],
      },
    });
  }, [categories, users]);

  useEffect(() => {
    getEmployments().then((data) =>
      setUsers(
        data.map((i) => {
          if (i?.user) {
            return i.user.email || i.user.phone_number;
          }
          return i.identifier;
        })
      )
    );
  }, []);

  const onSubmit = (values) => {
    setFilterData(values);
  };

  return (
    formDetails && (
      <Form formDetails={formDetails.details} form={form} onSubmit={onSubmit} />
    )
  );
};

export default StatisticsFilter;
